<div id="terms_popup" class="" *ngIf="showTerms">
    <div appDisableSelection class="close_button_top_left close_work_popup" (click)="closeTerms()"
        (keyup.enter)="closeTerms()" tabindex="0">X</div>
    <div appDisableSelection class="close_button_top_right close_work_popup" (click)="closeTerms()"
        (keyup.enter)="closeTerms()" tabindex="0">X</div>
    <div class="terms_content">
        <h1 i18n="@@encabezadoTerminos">Términos y Condiciones de Uso para Apps-Ds Portfolio</h1>

        <h2 i18n="@@tituloIntroduccion">1. Introducción</h2>
        <p i18n="@@textoIntroduccion">Bienvenidos a Apps-Ds Portfolio. Estos términos y condiciones rigen su uso de
            nuestro sitio web; al utilizar nuestro sitio web, usted acepta estos términos y condiciones en su totalidad.
            Si no está de acuerdo con estos términos y condiciones o cualquier parte de estos términos y condiciones, no
            debe utilizar nuestro sitio web.</p>

        <h2 i18n="@@tituloDerechosPropiedad">2. Derechos de Propiedad Intelectual</h2>
        <p i18n="@@textoDerechosPropiedad">Salvo que se indique lo contrario, nosotros o nuestros licenciantes poseemos
            los derechos de propiedad intelectual en el sitio web y el material en el sitio web. Todos estos derechos
            están reservados.</p>

        <h2 i18n="@@tituloUsoAceptable">3. Uso Aceptable</h2>
        <p i18n="@@textoUsoAceptable">Usted no debe utilizar nuestro sitio web de ninguna manera que cause, o pueda
            causar, daño al sitio web o deterioro de la disponibilidad o accesibilidad del sitio web; o de cualquier
            manera que sea ilegal, fraudulenta o dañina, o en relación con cualquier propósito o actividad ilegal,
            fraudulenta o dañina.</p>

        <h2 i18n="@@tituloLimitaciones">4. Limitaciones de Responsabilidad</h2>
        <p i18n="@@textoLimitaciones">La información en este sitio web se proporciona sin ninguna representación o
            garantía, expresa o implícita. No seremos responsables ante usted en relación con el contenido, uso o de
            cualquier otra manera en relación con este sitio web.</p>

        <h2 i18n="@@tituloPoliticaPrivacidad">5. Política de Privacidad</h2>
        <p i18n="@@textoPoliticaPrivacidad">Por favor, consulte nuestra Política de Privacidad a continuación para
            entender cómo recopilamos y usamos su información personal.</p>

        <h2 i18n="@@tituloModificaciones">6. Modificaciones</h2>
        <p i18n="@@textoModificaciones">Nos reservamos el derecho de revisar estos términos y condiciones de vez en
            cuando. La versión modificada de los términos y condiciones regirá el uso de nuestro sitio web a partir de
            la fecha de la publicación de la versión modificada en nuestro sitio web.</p>

        <h2 i18n="@@tituloLeyYJurisdiccion">7. Ley y Jurisdicción</h2>
        <p i18n="@@textoLeyYJurisdiccion">Estos términos y condiciones se regirán e interpretarán de acuerdo con las
            leyes de España, y cualquier disputa relacionada con estos términos y condiciones estará sujeta a la
            jurisdicción exclusiva de los tribunales de España.</p>

        <h2 i18n="@@tituloDetalles">8. Nuestros Detalles</h2>
        <p i18n="@@textoDetalles">Este sitio web es propiedad de Apps-Ds.<br>Puede contactarnos por correo electrónico a
            <a href="mailto:help@apps-ds.com">help&#64;apps-ds.com</a></p>

    </div>
    <div appDisableSelection class="close_button_bottom_left close_work_popup" (click)="closeTerms()"
        (keyup.enter)="closeTerms()" tabindex="0">X</div>
    <div appDisableSelection class="close_button_bottom_right close_work_popup" (click)="closeTerms()"
        (keyup.enter)="closeTerms()" tabindex="0">X</div>
</div>